module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FoodDiaryList"
    }
  }, [(_vm.hasFoods) ? _c('mu-list', {
    staticClass: "foods"
  }, _vm._l((_vm.foods), function(food, foodIndex) {
    return _c('mu-list-item', {
      key: ("food-item-" + foodIndex),
      staticClass: "food",
      attrs: {
        "disableRipple": ""
      }
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n        " + _vm._s('x' + food.servings + ' ' + (food.brand_name ? food.brand_name + ' - ' : '') + food.food_name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "serving",
      attrs: {
        "slot": "describe"
      },
      domProps: {
        "textContent": _vm._s(food.serving_description)
      },
      slot: "describe"
    }), _vm._v(" "), (_vm.userId === _vm.$store.state.user.scope.user_id) ? _c('mu-float-button', {
      staticClass: "trash",
      attrs: {
        "slot": "right",
        "icon": "delete",
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteFood(food, foodIndex)
        }
      },
      slot: "right"
    }) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.hasRecipes) ? _c('mu-list', {
    staticClass: "foods"
  }, _vm._l((_vm.recipes), function(recipe, recipeIndex) {
    return _c('mu-list-item', {
      key: ("food-item-" + recipeIndex),
      staticClass: "food",
      attrs: {
        "disableRipple": ""
      }
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n        " + _vm._s('x' + recipe.servings + ' ' + recipe.name) + _vm._s(recipe.length) + "\n      ")]), _vm._v(" "), (_vm.userId === _vm.$store.state.user.scope.user_id) ? _c('mu-float-button', {
      staticClass: "trash",
      attrs: {
        "slot": "right",
        "icon": "delete",
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteRecipe(recipe, recipeIndex)
        }
      },
      slot: "right"
    }) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.hasFoods && !_vm.hasRecipes) ? _c('div', {
    staticClass: "noFoods"
  }, [(_vm.tab !== 'All') ? _c('p', [_vm._v("You added no foods for "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.tab)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-row', {
    staticClass: "totals"
  }, _vm._l((_vm.nutritionalKeys), function(nutrition, nutritionIndex) {
    return _c('mu-col', {
      key: ("nutrition-" + nutritionIndex),
      staticClass: "nutrition",
      attrs: {
        "tablet": "20",
        "desktop": "20",
        "width": "20"
      }
    }, [_c('div', {
      staticClass: "value",
      domProps: {
        "textContent": _vm._s(("" + (_vm.getValueByNutritionKey(nutrition.key).toFixed(1)) + (nutrition.unit)))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "label",
      domProps: {
        "textContent": _vm._s(nutrition.label)
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5412e17c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/FoodDiary/FoodDiaryTab.vue
// module id = 3177
// module chunks = 1